<template>
  <div style="height: 100%;">
    <Echart
      :options="options"
      id="centreLeft1Chart"
      height="100%"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from './echart/bar'
export default {
  data () {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler (newData) {
        this.options = {
          color: [
            "#37a2da",
            "#32c5e9",
            "#9fe6b8",
            "#ffdb5c",
            "#ff9f7f",
            "#fb7293",
            "#e7bcf3",
            "#8378ea"
          ],
          tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c}公顷<br/>占比： {d}%"
        },
          toolbox: {
            show: true
          },
          grid: {
            // x: "0%",
            // width: "88%",
            // y: "4%",
            // top:"5%",
            // left: '2%',
            // right: '2%',
            // bottom: '10%',
            left: '3%',
            right: '4%',
            bottom: '50%',
            containLabel: true,
            //  show:'true',
            borderWidth: '0'
          },
          calculable: true,
          legend: {
            orient: "horizontal",
            icon: "circle",
            bottom: 0,
            x: "center",
            data: newData.xData,
            textStyle: {
              color: "#fff"
            }
          },
          
          series: [
            {
              name: "退化草原",
              type: "pie",
              radius: "50%",
              // roseType: "area",
              // center: ["50%", "40%"],
              data: newData.seriesData,
              label: {
              fontSize: 10,
              normal: {
                formatter: "{c|{c}公顷}\n {d|{d}%}",
                rich: {
                  c: {
                    color: "#fff"
                  },
                  d: {
                    color: "#00ffe4"
                  }
                }
              },
              labelLine:{
                length:1
              }
            },
            }
          ]
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>